import { render } from "react-dom";
import React from "react";
import { AddToBasket } from "./products/components/add_to_basket";

var product_id = document
  .querySelector(".product-detail__add-to-basket")
  .getAttribute("data-product-id");

render(
  React.createElement(AddToBasket, { product_id }),
  document.querySelector(".product-detail__add-to-basket")
);
